import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';
import { environment } from '@env';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChatUploadHelperService {
  constructor(private apiService: ApiService) {}

  uploadAttachmentFile(
    file: File,
    requisitionId: string,
  ): Observable<{
    id: string;
    original: string | null;
    stored: string | null;
    size: number;
    download_url: string | null;
  }> {
    const url = `${environment.environmentVariables.apiCoreUrl}/Attachment/${requisitionId}/Chat`;
    const formData = new FormData();
    formData.append('file', file);

    return this.apiService.postWithForm(url, formData);
  }
}
